import { Card, CardContent } from '@/components/ui/card'
import Loader from '@/components/ui/Loader'
import { getCoreRowModel, useReactTable } from '@tanstack/react-table'
import EmptyDatas from 'components/ui/EmptyDatas'
import Table from 'components/ui/my-data-table'
import React, { useMemo, useState } from 'react'
import useSWR from 'swr'
import { columns } from './data-table-column'
import DataTableToolbar from './data-table-toolbar'

const matchLoadedToning = (item, query) => {
  const q = query.trim().toLowerCase()
  if (!q) return true
  const name = String(item?.name || '').toLowerCase()
  const id = String(item?.id || '').toLowerCase()
  return name.includes(q) || id.includes(q)
}

const CommTonings = () => {
  const [search, setSearch] = useState('')
  const { data, isLoading, isValidating, mutate } = useSWR([
    '/tonings/template',
  ])

  const filteredData = useMemo(
    () => (data ?? []).filter((item) => matchLoadedToning(item, search)),
    [data, search],
  )

  const table = useReactTable({
    data: filteredData,
    columns,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="mb-2 flex-shrink-0">
        <DataTableToolbar
          mutate={mutate}
          search={search}
          onSearchChange={setSearch}
        />
      </div>
      <div className="min-h-0 flex-1">
        {isLoading || isValidating ? (
          <Loader />
        ) : !data ? (
          <EmptyDatas />
        ) : (
          <Card className="flex h-full flex-col">
            <CardContent className="flex-1 overflow-hidden pb-0 pl-4 pr-0">
              <div className="h-full overflow-auto">
                <Table table={table} />
              </div>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  )
}

export default CommTonings
